import {
  Stack,
  Text,
  Heading,
  Columns,
  Column,
  Hidden,
} from 'braid-design-system';
import React from 'react';

import ExternalLink from 'src/components/ExternalLink/ExternalLink';
import LegacyCarousel from 'src/components/LegacyCarousel/LegacyCarousel';
import ArticleCard from 'src/components/LegacyCarousel/components/ArticleCard/ArticleCard';
import Section from 'src/views/Franchise/components/Section/Section';

import { articles } from './data';

const carouselCards = () =>
  articles().map((card, index) => (
    <ArticleCard key={index} htag={`starting-out-item-${index}`} {...card} />
  ));

const StartingOut = () => (
  <Section>
    <Stack space="medium">
      <Heading level="2">Starting out?</Heading>
      <Columns space="none">
        <Column>
          <Text>Advice and tips on your first steps.</Text>
        </Column>
        <Column width="content">
          <Hidden below="tablet">
            <Text>
              <ExternalLink destination="/business-resources/category/buying-a-business">
                See all
              </ExternalLink>
            </Text>
          </Hidden>
        </Column>
      </Columns>
      <LegacyCarousel
        buttonOffsetTop={160}
        itemToShow={3}
        items={carouselCards()}
      />
    </Stack>
  </Section>
);

export default StartingOut;
